import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';
import Loader from '../../components/Loader';

// ==============================|| ANALYZER GUARD ||============================== //
// This guard blocks users without Analyzer role from accessing analyzer routes

const AnalyzerGuard = ({ children }: GuardProps) => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }

    const hasAnalyzerRole = user?.roles?.includes('Analyzer');

    if (!hasAnalyzerRole) {
      // Redirect users without Analyzer role to home
      navigate('/', { replace: true });
    } else {
      setIsChecking(false);
    }
  }, [isAuthenticated, navigate, user]);

  if (isChecking) {
    return <Loader />;
  }

  return children;
};

export default AnalyzerGuard;
